var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.025,
    height: 18,
    viewBox: "0 0 18.025 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-big-logo",
    transform: "translate(0 -0.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M2.4.183a2.4,2.4,0,1,0,2.4,2.4A2.406,2.406,0,0,0,2.4.183Z",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M8.083,83.531H4.477a.311.311,0,0,0-.311.311V95.45a.311.311,0,0,0,.311.311H8.083a.311.311,0,0,0,.311-.311V83.842A.311.311,0,0,0,8.083,83.531Z",
    transform: "translate(-3.878 -77.578)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M96.2,81.557a4.736,4.736,0,0,0-3.187,1.057V82a.311.311,0,0,0-.311-.311h-3.46a.311.311,0,0,0-.311.311V93.613a.311.311,0,0,0,.311.311h3.6a.311.311,0,0,0,.311-.311V87.87c0-1.648.3-2.669,1.816-2.669,1.49,0,1.6,1.1,1.6,2.768v5.645a.311.311,0,0,0,.311.311h3.6a.311.311,0,0,0,.311-.311V87.245C100.8,84.6,100.28,81.557,96.2,81.557Z",
    transform: "translate(-82.778 -75.74)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.36af5c76480954a01a2f7fc81b162b35.svg";
export { ForwardRef as ReactComponent };